<app-header-dashboard/>
<main id="main" class="main">
  <section class="section dashboard">
    <div class="row">
      <router-outlet></router-outlet>
    </div>
  </section>
</main>
